import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import ConfirmModal from '../modals/ConfirmModal.jsx';
import useMarketPlaceModal from "../../pages/Layout/DashboardLayout/MarketPlaceModal/useMarketPlaceModal";
import { locationWiseData } from '../../services/regionalLevelSales';
import { crown, dummyImage } from "../../../images/index.js";
import AreaTableModal from "../modals/AreaTableModal.jsx";
import { usePermissions } from "../../context/PermissionContext.js";
import { getColumnSetting } from "../../services/columnSetting.js";
import { useLocation } from "react-router-dom";

const NormalTable = ({
  tableId,
  data,
  selectedIds = { categoryId: [], productId: [] },
  onSelectionChange,
  idKey = "id",
  typeKey = "type",
  enableSelection = true,
  prioritizeSelected = false,
  defaultPageLength = 10,
  refreshTrigger,
  onCategoryClick,
  onParentProductClick,
  loading = false,
  sequence,
  filterData = {},
  downloadBtnPermission = true,
  isProductwiseTable = false,
  onColumnChange = () => { },
  showSelectColumn = false,
  section
}) => {
  const { handleConnect } = useMarketPlaceModal();
  const [modalOpenLoading, setModalOpenLoding] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const containerRef = useRef(null);
  const selectedIdsRef = useRef(new Set());
  const [showInfoComponent, setShowInfoComponent] = useState(false);
  const [infoData, setInfoData] = useState({ column: "", rowId: "" });
  const [delayedEmpty, setDelayedEmpty] = useState(false);
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const { formattedStart, formattedEnd, level } = filterData;
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [tempColumns, setTempColumns] = useState([]);
  const headersRef = useRef([]); // store headers globally
  const [allColumns, setAllColumns] = useState([]);
  const location = useLocation();
  const [selectedLocationDetails, setSelectedLocationDetails] = useState({
    state: "",
    city: "",
    pincode: ""
  });
  const permission = usePermissions();
  const parseTableId = (tableId = "") => {
    const cityMatch = tableId.match(/rrCity-([^\s]+)/);
    const pincodeMatch = tableId.match(/rrPincode-([^\s]+)/);
    const stateMatch = tableId.match(/rrSales-([^\s]+)/);

    return {
      city: cityMatch ? cityMatch[1] : "",
      pincode: pincodeMatch ? pincodeMatch[1] : "",
      state: stateMatch ? stateMatch[1] : ""
    };
  };


  useEffect(() => {
    if (!loading) {
      if (Array.isArray(data) && data.length === 0) {
        setDelayedEmpty(true);
      } else {
        setDelayedEmpty(false);
      }
    } else {
      setDelayedEmpty(false);
    }
  }, [loading, data]);


  useEffect(() => {
    const flatSelected = [
      ...(selectedIds.productId || []),
      ...(selectedIds.categoryId || [])
    ];
    selectedIdsRef.current = new Set(flatSelected);
  }, [selectedIds]);

  const parseCurrency = (value) => {
    if (typeof value !== "string" && typeof value !== "number") return null;

    // Normalize and clean input
    let str = String(value).trim().replace(/[₹,%\s]/g, '').toUpperCase();

    // Handle Crores
    if (str.endsWith('CR')) {
      const num = parseFloat(str.replace('CR', ''));
      return isNaN(num) ? null : num * 10000000;
    }

    // Handle Lakhs
    if (str.endsWith('L')) {
      const num = parseFloat(str.replace('L', ''));
      return isNaN(num) ? null : num * 100000;
    }

    // Handle Thousands
    if (str.endsWith('K')) {
      const num = parseFloat(str.replace('K', ''));
      return isNaN(num) ? null : num * 1000;
    }

    // Handle plain numeric with commas (e.g., "1,962")
    str = str.replace(/,/g, '');
    const numeric = parseFloat(str);
    return isNaN(numeric) ? null : numeric;
  };

  useEffect(() => {
    const fetchColumns = async () => {
      try {
        const res = await getColumnSetting(section);

        if (res?.data?.success && Array.isArray(res?.data?.data)) {
          const apiColumns = res.data.data; // full array

          setAllColumns(apiColumns); // <-- NEW STATE
          setTempColumns(
            apiColumns.filter(c => c.visible).map(c => c.key)
          );
          setVisibleColumns(
            apiColumns.filter(c => c.visible).map(c => c.key)
          );
        }
      } catch (err) {
        console.error("Column fetch failed", err);
      }
    };
    if (section) {
      fetchColumns();
    }
  }, [section, tableId, typeKey, location.pathname]);

  useEffect(() => {
    if (headersRef.current.length && tempColumns.length) {
      setVisibleColumns(tempColumns);
    }
  }, [tempColumns]);


  // useEffect(() => {
  //   if (headersRef.current.length > 0 && visibleColumns.length === 0) {
  //     setVisibleColumns(headersRef.current);
  //     setTempColumns(headersRef.current);
  //   }
  // }, [headersRef.current]);

  useEffect(() => {
    const initialize = async () => {
      if (!containerRef.current) return;

      try {
        const existingTable = $(`#${tableId}`);
        if ($.fn.DataTable.isDataTable(existingTable)) {
          existingTable.DataTable().clear().destroy(true);
          existingTable.remove();
        }

        if (loading) {
          containerRef.current.innerHTML = getSkeletonTableHTML();
          return;
        }

        if (!data.length) {
          // Wait until delayedEmpty is true
          if (delayedEmpty) containerRef.current.innerHTML = "";
          return;
        }


        await import("../../../datatable.js");

        const sortByType = (a, b) => {
          const priority = { Category: 0, Product: 1 };
          return (priority[a.type] ?? 2) - (priority[b.type] ?? 2);
        };

        const processedData = prioritizeSelected
          ? [...data].sort((a, b) => {
            const idA = a[idKey]?.toString();
            const idB = b[idKey]?.toString();
            const selectedDiff =
              Number(selectedIdsRef.current.has(idB)) -
              Number(selectedIdsRef.current.has(idA));
            if (selectedDiff !== 0) return selectedDiff;
            return sortByType(a, b);
          })
          : [...data].sort(sortByType);

        const showASIN_SKU = ["productGrowthId", "salesByState", "topSellingProducts", "topSellingCategory"].includes(tableId);

        // Only add BRAND/ASIN/SKU export columns if at least one row is a Product/Variation
        // with an actual asin or sku value — skip for category-only views.
        const hasProductCols = processedData.some(row =>
          row?.asin?.trim?.() || row?.sku?.trim?.()
        );

        let headers = Object.keys(processedData[0] || {}).filter((h) => {
          const excludeFields = ["type", "image"];
          if (!showASIN_SKU) {
            excludeFields.push("asin", "sku", "brand");
          }
          return !excludeFields.includes(h);
        });

        headersRef.current = headers;

        // if (visibleColumns.length === 0) {
        //   setVisibleColumns(headers);
        //   setTempColumns(headers);
        // }

        const columnMapping = {
          actual_units: "actual_sold_units",
        };        // Apply sequence.columns if defined and is a valid array
        if (Array.isArray(sequence?.columns) && sequence.columns.length > 0) {
          headers = sequence.columns
            .map(col => columnMapping[col] || col)
            .filter(col => headers.includes(col));
        }
        const hasStatus = processedData.some(item => item.status !== undefined && item.status !== null && item.status !== "");
        if (hasStatus) {
          // Remove status from headers if it exists to avoid duplicates
          headers = headers.filter(h => h !== "status");
          const nameIndex = headers.indexOf("name");
          if (nameIndex !== -1) {
            headers.splice(nameIndex + 1, 0, "status");
          } else {
            headers.push("status");
          }
        }

        const mandatoryColumns = ["name"];
        if (hasStatus) {
          mandatoryColumns.push("status");
        }
        if (showASIN_SKU) {
          mandatoryColumns.push("asin", "sku", "brand");
        }
        const isColumnVisible = (key) => {
          if (mandatoryColumns.includes(key)) return true;
          return visibleColumns.length === 0 || visibleColumns.includes(key);
        };

        const formatValue = (num, hasRupee, hasPercent, originalSample) => {
          if (num === null || isNaN(num)) return "";

          if (hasPercent) {
            return `${num.toFixed(2)}%`;
          }

          const hasDecimals = originalSample && originalSample.includes('.');
          let formattedNum = num.toLocaleString('en-IN', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: 2
          });

          if (hasRupee) {
            return `₹${formattedNum}`;
          }

          return formattedNum;
        };

        const renderFooterHTML = () => {
          const footerCols = headers
            .filter(h => h !== idKey && h !== "actual_units_display")
            .filter(key => isColumnVisible(key));

          return `
            <tfoot class="table-footer" style="font-weight: bold; border-top: 2px solid #dee2e6; background-color: #f8f9fa;">
              <tr>
                <td class="not_export" style="display:none"></td>
                ${enableSelection ? `<td class="sticky-col checkbox-col not_export" style="background-color: #f8f9fa;"></td>` : ""}
                ${footerCols
              .map((key, idx) => {
                const extraClass = (!enableSelection && idx === 0) || (enableSelection && idx === 0)
                  ? "sticky-col name-col"
                  : "";
                const inlineStyle = extraClass ? `style="background-color: #f8f9fa;"` : ``;

                if (idx === 0) {
                  // Insert 3 hidden export-only cells right after the Name/Total cell
                  const hiddenCells = (hasProductCols && !showASIN_SKU)
                    ? `<td class="export_only" style="display:none;"></td>
                       <td class="export_only" style="display:none;"></td>
                       <td class="export_only" style="display:none;"></td>`
                    : "";
                  return `<td class="${extraClass}" ${inlineStyle}><strong>Total</strong></td>${hiddenCells}`;
                }

                const values = processedData.map(row => (key === "actual_units" && row["actual_units_display"] !== undefined) ? row["actual_units_display"] : row[key]);
                let hasRupee = false;
                let hasPercent = false;
                let originalSample = "";

                const parsedValues = values.map(val => {
                  if (val === null || val === undefined) return null;
                  const valStr = String(val);
                  if (valStr.includes("₹")) hasRupee = true;
                  if (valStr.includes("%")) hasPercent = true;
                  if (valStr.trim() !== "") originalSample = valStr;
                  return parseCurrency(val);
                }).filter(v => v !== null && !isNaN(v));

                if (parsedValues.length === 0) {
                  return `<td class="${extraClass}" ${inlineStyle}></td>`;
                }

                const keyLower = key.toLowerCase();
                const isPercentage = hasPercent ||
                  keyLower.includes("percentage") ||
                  keyLower.includes("rate") ||
                  keyLower.includes("pct") ||
                  keyLower.includes("ctr") ||
                  keyLower.includes("acos") ||
                  keyLower.includes("tacos") ||
                  keyLower.includes("roas") ||
                  keyLower.includes("wow") ||
                  keyLower.includes("mom") ||
                  keyLower === "share";

                const isRateOrAverage = (keyLower.includes("percentage") && keyLower !== "percentage") ||
                  hasPercent ||
                  keyLower.includes("rate") ||
                  keyLower.includes("pct") ||
                  keyLower.includes("ctr") ||
                  keyLower.includes("acos") ||
                  keyLower.includes("tacos") ||
                  keyLower.includes("roas") ||
                  keyLower.includes("wow") ||
                  keyLower.includes("mom") ||
                  keyLower.includes("cpc") ||
                  keyLower.includes("share") ||
                  keyLower.includes("price");

                let resultValue;
                if (isRateOrAverage) {
                  // Average for rate/percentage columns
                  resultValue = parsedValues.reduce((acc, curr) => acc + curr, 0) / parsedValues.length;
                } else {
                  // Sum for numeric/currency columns
                  resultValue = parsedValues.reduce((acc, curr) => acc + curr, 0);
                }
                const displayVal = formatValue(resultValue, hasRupee, isPercentage, originalSample);
                return `<td class="${extraClass}" ${inlineStyle}><strong>${displayVal}</strong></td>`;
              })
              .join("")}
              </tr>
            </tfoot>
          `;
        };

        const tableHTML = `

        <div class="table-scroll-wrapper" id="scroll-wrapper-${tableId}">
          <table id="${tableId}" class="display table freeze-table" style="width:100%">
            <thead class="table-header">
              <tr class="table-header">
              <th class="not_export" style="display:none"></th>
                ${enableSelection ? `<th class="sticky-col checkbox-col not_export table-header kpi-name"><input type="checkbox" id="select-all-on-page" /></th>` : ""}
                ${headers
            .filter(h => h !== idKey)
            .filter(key => isColumnVisible(key))
            .map((h, idx) => {
              let label = h
                .replace(/_/g, " ")
                .split(" ")
                .map(word => {
                  const lower = word.toLowerCase();
                  if (lower === "percentage") return "%";
                  if (lower === "ads") return "Ads";
                  if (lower === "tacos") return "TACoS";
                  return word.toUpperCase();
                })
                .join(" ");
              const extraClass = (!enableSelection && idx === 0) || (enableSelection && idx === 0)
                ? "sticky-col name-col table-header"
                : "table-header";
              // Inject hidden export columns right after the NAME header (idx 0)
              const hiddenHeaders = (idx === 0 && hasProductCols && !showASIN_SKU)
                ? `<th class="export_only" style="display:none;">BRAND</th>
                   <th class="export_only" style="display:none;">ASIN</th>
                   <th class="export_only" style="display:none;">SKU</th>`
                : "";
              return `<th class="${extraClass}">${label}</th>${hiddenHeaders}`;
            })
            .join("")}
              </tr>
            </thead>
            <tbody style="vertical-align: middle;"> 
              ${processedData
            .map(row => {
              const rowId = row[idKey]?.toString() || "";
              const rowType = row[typeKey]?.toString() || "";
              const isChecked = selectedIdsRef.current.has(rowId) ? "checked" : "";
              const isSelected = selectedIdsRef.current.has(rowId);
              return `
                    <tr data-id="${rowId}" data-type="${rowType}">
                    <td class="not_export" style="display:none">${isSelected ? 0 : 1}</td>
                      ${enableSelection
                  ? `<td class="sticky-col checkbox-col not_export table-header-content"><input type="checkbox" class="row-checkbox normal-custom-checkbox" data-id="${rowId}" data-type="${rowType}" ${isChecked} /></td>`
                  : ""
                }
                      ${headers
                  .filter(key => key !== idKey)
                  .filter(key => isColumnVisible(key))
                  .map((key, idx) => {
                    const cellValue = row[key];
                    const orderValue = parseCurrency(cellValue);
                    const extraClass = (!enableSelection && idx === 0) || (enableSelection && idx === 0)
                      ? "sticky-col name-col table-header-content"
                      : "";

                    const cellContent =
                      key === "type" || key === "image"
                        ? ""
                        : key === "name"
                          ? `<div style="display: flex; align-items: center; gap: 10px;">
                            ${!row.hasOwnProperty("image")
                            ? ""
                            : row["image"] || (row["type"] === "Product" || row["type"] === "variation" || row["type"] === "Parent Product")
                              ? `<img src="${row["image"] && row["image"].trim() !== "" ? row["image"] : dummyImage
                              }" alt="${row["parent_category"] || "image"}" width="70" height="70" style="border-radius:4px;object-fit:cover;" />`
                              : row["image"] || row["image"] === null
                                ? `<img alt="Dummy image" src="${dummyImage}" width="70" height="70" class="dummy-img"/>`
                                : ""
                          }
                                 <div>
                                   ${row["type"] === "Category"
                            ? `<span class="truncate-2-lines clickable-category"
                                                 data-id="${rowId}"
                                                 data-asin="${cellValue}"
                                                 style="cursor:pointer; color:#007bff;"
                                                 title="${cellValue}">
                                              ${cellValue}
                                           </span>`
                            : row["type"] === "Parent Product"
                              ? `<span class="truncate-2-lines clickable-parent"
                                                 data-parent-id="${rowId}"
                                                 data-product-id="${row["product_id"] || rowId}"
                                                 data-asin="${row["asin"] || row["sku"]}"
                                                 style="cursor:pointer;color:#28a745;"
                                                 title="${cellValue}">
                                              ${cellValue}
                                           </span>`
                              : row?.asin?.trim?.()
                                ? `<a href="https://www.amazon.in/dp/${row["asin"]}" target="_blank"
                                              class="truncate-2-lines"
                                              style="cursor:pointer;color:#007bff;text-decoration:none;"
                                              title="${cellValue}">
                                              ${cellValue}
                                           </a>`
                                : row?.sku?.trim?.()
                                  ? `<a href="https://www.amazon.in/s?k=${row["sku"]}" target="_blank"
                                              class="truncate-2-lines"
                                              style="cursor:pointer;color:#007bff;text-decoration:none;"
                                              title="${cellValue}">
                                              ${cellValue}
                                           </a>`
                                  : `<span class="truncate-2-lines" title="${cellValue}">${cellValue}</span>`
                          }
                                   <div style="min-width:200px; font-size:14px; margin-top: 4px;">
                                      ${row?.brand?.trim?.() || row?.asin?.trim?.() || row?.sku?.trim?.()
                            ? `<div class='custom-text-dark' style="font-size:12px;">
                                              ${row?.brand?.trim?.()
                              ? `Brand: <span class='text-muted' style="color:#555;">${row["brand"]}</span><br/>`
                              : ""
                            }
                                              ${row?.asin?.trim?.()
                              ? `ASIN: <span style="color:#555;" class='text-muted'>${row["asin"]}</span>`
                              : ""
                            }
                                              ${row?.asin?.trim?.() && row?.sku?.trim?.()
                              ? "&nbsp;&nbsp;|&nbsp;&nbsp;"
                              : ""
                            }
                                              ${row?.sku?.trim?.()
                              ? `SKU: <span style="color:#555;" class='text-muted'>${row["sku"]}</span>`
                              : ""
                            }
                                             </div>`
                            : ""
                          }
                                    </div>
                                 </div>
                                </div>`
                          : key.toLowerCase() === "location"
                            ? `<span class="clickable-location" data-rowid="${rowId}" style="cursor:pointer;color:#007bff;text-decoration:underline;">
                                   ${cellValue}
                                 </span>`
                            : cellValue === "i"
                              ? `<span class="clickable-i" data-key="${key}" data-id="${rowId}" title="Connect your Ads Account"> <img class="normal-table-crown-img" src="${crown}"/> </span>`
                            : key === "status"
                              ? (() => {
                                const status = cellValue || "";
                                let cls = "";
                                let customStyle = "";
                                if (status.toLowerCase() === "active") {
                                  cls = "enabled";
                                } else if (status.toLowerCase() === "inactive" || status.toLowerCase() === "incomplete") {
                                  cls = "paused";
                                } else {
                                  customStyle = "background: #e2e8f0; color: #475569;";
                                }
                                return `<span class="badge ${cls}" style="${customStyle}">${status}</span>`;
                              })()
                              : cellValue ?? "";


                    // Inject hidden BRAND/ASIN/SKU cells right after the NAME cell (idx 0)
                    const hiddenCells = (idx === 0 && hasProductCols && !showASIN_SKU)
                      ? `<td class="export_only" style="display:none;">${(row?.brand || "").replace(/"/g, '&quot;')}</td>
                         <td class="export_only" style="display:none;">${(row?.asin || "").replace(/"/g, '&quot;')}</td>
                         <td class="export_only" style="display:none;">${(row?.sku || "").replace(/"/g, '&quot;')}</td>`
                      : "";

                    return (orderValue == null
                      ? `<td class="${extraClass}">${cellContent}</td>`
                      : `<td class="${extraClass}" data-order="${orderValue}">${cellContent}</td>`) + hiddenCells;
                  })
                  .join("")}
                    </tr>`;
            })
            .join("")}
            </tbody>
            ${renderFooterHTML()}
          </table>
        </div>
        `;

        containerRef.current.innerHTML = tableHTML;
        // containerRef.current.innerHTML = showSelectColumn ? `
        // <div class="table-toolbar-custom">

        //   <div></div>

        //   <div style="display:flex; gap:0px; align-items:center;">

        //     <div id="column-dropdown-${tableId}"></div>

        //     <div id="download-btn-${tableId}"></div>
        //   </div>
        // </div>

        //   ${tableHTML}
        // `:tableHTML;


        setTimeout(() => {
          const container = document.getElementById(`column-dropdown-${tableId}`);
          if (!container) return;

          container.innerHTML = `
          <button id="col-btn-${tableId}" class="btn btn-secondary buttons-csv buttons-html5">
          <i class="bi bi-funnel"></i>
          </button>


          <div class="col-dropdown-box" id="col-dropdown-box-${tableId}"></div>
        `;

          const btn = document.getElementById(`col-btn-${tableId}`);
          const box = document.getElementById(`col-dropdown-box-${tableId}`);
          const excludedColumns = ["id", "asin", "image", "name", "sku", "brand", "status", "actual_units"];

          btn.onclick = () => {
            box.style.display = box.style.display === "none" ? "block" : "none";
            renderCheckboxList();
          };

          const renderCheckboxList = () => {
            box.innerHTML = `
          <div class="dropdown-select-all">
            <input type="checkbox" id="select-all-cols-${tableId}" />
            <label style="font-weight:500;">Select All</label>
          </div>
          <div style="max-height:180px; overflow:auto;">
            ${allColumns
                .filter(colObj => !excludedColumns.includes(colObj.key))
                .map(colObj => {
                  const col = colObj.key;

                  const label = col
                    .replace(/_/g, " ")
                    .split(" ")
                    .map(word => {
                      const lower = word.toLowerCase();
                      if (lower === "percentage") return "%";
                      if (lower === "ads") return "Ads";
                      if (lower === "tacos") return "TACoS";
                      if (lower === "acos") return "ACOS";
                      if (lower === "roas") return "ROAS";
                      if (lower === "ctr") return "CTR";
                      if (lower === "cpc") return "CPC";
                      return word.charAt(0).toUpperCase() + word.slice(1);
                    })
                    .join(" ");

                  return `
                  <div class="truncate-2-lines">
                    <input type="checkbox" 
                      ${tempColumns.includes(col) ? "checked" : ""} 
                      data-col="${col}" />
                    <label>${label}</label>
                  </div>
                `;
                }).join("")}
          </div>

            <div style="display:flex; justify-content:space-between; margin-top:10px;">
            <button id="close-col-${tableId}" class="btn btn-light w-sm-auto px-3 py-0 rounded-3 border shadow-sm">Close</button>
              <button id="update-col-${tableId}" class="btn plan-detail-card-btn rounded-3">Update</button>
            </div>
          `;

            const selectAllEl = document.getElementById(`select-all-cols-${tableId}`);
            const columnCheckboxes = box.querySelectorAll("input[data-col]");

            // all valid columns
            const dropdownColumns = allColumns
              .filter(colObj => !excludedColumns.includes(colObj.key))
              .map(c => c.key);

            //  set initial state
            selectAllEl.checked = dropdownColumns.every(col => tempColumns.includes(col));
            selectAllEl.onchange = (e) => {
              if (e.target.checked) {
                setTempColumns([...new Set([...tempColumns, ...dropdownColumns])]);

                columnCheckboxes.forEach(cb => {
                  cb.checked = true;
                });

              } else {
                const updated = tempColumns.filter(col => !dropdownColumns.includes(col));
                setTempColumns(updated);

                columnCheckboxes.forEach(cb => {
                  cb.checked = false;
                });
              }
            };

            columnCheckboxes.forEach(cb => {
              cb.onchange = (e) => {
                const col = e.target.getAttribute("data-col");

                let updated;

                if (e.target.checked) {
                  updated = [...tempColumns, col];
                } else {
                  updated = tempColumns.filter(c => c !== col);
                }

                setTempColumns(updated);

                //  sync select all
                selectAllEl.checked = dropdownColumns.every(col => updated.includes(col));
              };
            });
            document.getElementById(`update-col-${tableId}`).onclick = async () => {
              const selectedCols = [];

              box.querySelectorAll("input[data-col]").forEach(cb => {
                if (cb.checked) selectedCols.push(cb.getAttribute("data-col"));
              });

              const excludedColumns = ["id", "asin", "image", "name", "sku", "brand", "status"];

              //  merge excluded columns (force visible)
              const finalSelectedCols = [
                ...new Set([...selectedCols, ...excludedColumns])
              ];

              setVisibleColumns(finalSelectedCols);
              setTempColumns(finalSelectedCols);

              onColumnChange?.(finalSelectedCols, headersRef.current);

              box.style.display = "none";
            };
            document.getElementById(`close-col-${tableId}`).onclick = () => {
              setTempColumns(visibleColumns);
              box.style.display = "none";
            };
          };
        }, 0);

        const idColIndex = headers.findIndex(h => h === idKey);
        const checkboxOffset = enableSelection ? 1 : 0;

        window.initializeNormalDataTable({
          selector: `#${tableId}`,
          custom_class: "normalTable",
          pageLength: defaultPageLength,
          ordering: true,
          order: [],
          columnDefs: [
            ...(enableSelection ? [{ targets: 0, orderable: false }] : []),
            // { targets: idColIndex + checkboxOffset, visible: false },
          ],
          downloadBtnPermission,
          isProductwiseTable
        });

        const dt = $(`#${tableId}`).DataTable();
        dt.buttons().container().appendTo(`#download-btn-${tableId}`);

        if (showSelectColumn) {
          const filterContainer = document.querySelector(
            `#${tableId}_wrapper .custom_data_filter_col .col-6.text-end`
          );

          if (filterContainer) {
            filterContainer.innerHTML = `
            <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px;">
              <div id="column-dropdown-${tableId}"></div>
              <div id="download-btn-${tableId}"></div>
            </div>
          `;
          }
        }
        dt.buttons().container().appendTo(`#download-btn-${tableId}`);

        const $table = $(`#${tableId}`).DataTable();
        $table.draw();

        const emitGroupedSelected = () => {
          const grouped = { categoryId: [], productId: [] };
          selectedIdsRef.current.forEach((id) => {
            const $row = $(`#${tableId} tbody tr[data-id="${id}"]`);
            const type = $row.data("type");
            if (type === "Category") grouped.categoryId.push(id);
            else grouped.productId.push(id);
          });
          onSelectionChange?.(grouped);
        };

        const handleHeaderSelectAll = () => {
          const selectAllCheckbox = document.getElementById("select-all-on-page");
          if (!selectAllCheckbox) return;

          selectAllCheckbox.addEventListener("click", (e) => e.stopPropagation());

          selectAllCheckbox.addEventListener("change", function () {
            const rows = $table.rows({ page: 'current' }).nodes();

            $(rows).find(".row-checkbox").each(function () {
              const rowId = $(this).data("id")?.toString();
              if (!rowId) return;

              this.checked = selectAllCheckbox.checked;

              if (selectAllCheckbox.checked) {
                selectedIdsRef.current.add(rowId);
              } else {
                selectedIdsRef.current.delete(rowId);
              }
            });

            emitGroupedSelected();
          });
        };

        handleHeaderSelectAll();

        const restoreCheckboxStates = () => {
          var selectAllCheckbox = document.getElementById("select-all-on-page");
          const checkboxes = containerRef.current.querySelectorAll(".row-checkbox");
          // If no select-all checkbox exists, just exit early
          if (!selectAllCheckbox) return;

          if (checkboxes.length === 0) {
            selectAllCheckbox.checked = false; // <-- Force uncheck when no row-checkbox exists
            return;
          }
          let allChecked = true;

          checkboxes.forEach(cb => {
            const rowId = cb.getAttribute("data-id");
            const isChecked = selectedIdsRef.current.has(rowId);
            cb.checked = isChecked;
            if (!isChecked) allChecked = false;
          });

          if (selectAllCheckbox) {
            selectAllCheckbox.checked = allChecked;
          }
        };

        requestAnimationFrame(() => restoreCheckboxStates());
        $table.on("draw", restoreCheckboxStates);

        $(`#${tableId} tbody`)
          .off("change")
          .on("change", ".row-checkbox", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const table = $(`#${tableId}`).DataTable();
            const row = $(this).closest("tr");

            const isChecked = this.checked;

            // ✅ Update hidden column value
            table.cell(row, 0).data(isChecked ? 0 : 1);

            const rowId = $(this).data("id")?.toString();

            if (isChecked) {
              selectedIdsRef.current.add(rowId);
            } else {
              selectedIdsRef.current.delete(rowId);
            }


            // ✅ Emit grouped selection
            if (typeof emitGroupedSelected === "function") {
              emitGroupedSelected();
            }
            table.order([[0, "asc"]]).draw(false);

            // ✅ CUSTOM SORT (no DataTable cell overwrite)
            // const rows = table.rows({ page: "current" }).nodes();

            // const sortedRows = Array.from(rows).sort((a, b) => {
            //   const aChecked = $(a).find(".row-checkbox").prop("checked") ? 1 : 0;
            //   const bChecked = $(b).find(".row-checkbox").prop("checked") ? 1 : 0;

            //   if (bChecked !== aChecked) return bChecked - aChecked;

            //   const aText = $(a).find("td:eq(2)").text().trim();
            //   const bText = $(b).find("td:eq(2)").text().trim();

            //   return aText.localeCompare(bText);
            // });

            // $(table.table().body()).append(sortedRows);

            // ✅ Select All sync
            let allChecked = true;
            $(rows).find(".row-checkbox").each(function () {
              if (!this.checked) {
                allChecked = false;
                return false;
              }
            });

            const selectAllCheckbox = document.getElementById("select-all-on-page");
            if (selectAllCheckbox) {
              selectAllCheckbox.checked = allChecked;
            }
          });
        $(`#${tableId} tbody`).on("click", ".clickable-i", function () {
          const key = $(this).data("key");
          const id = $(this).data("id");
          setInfoData({ column: key, rowId: id });
          setShowInfoComponent(true);
          setModalOpen(true);
        });

        $table.on("click", ".clickable-location", async function () {
          const rowId = $(this).data("rowid")?.toString();
          const selectedRow = data.find(r => r[idKey]?.toString() === rowId);

          if (!rowId) return;
          setSelectedLocationName(selectedRow?.location || rowId); //  location name
          const parsed = parseTableId(tableId);
          setSelectedLocationDetails(parsed);
          setLocationModalOpen(true); // show modal

          try {
            setLocationLoading(true);

            const {
              productId = [],
              categoryId = [],
              parentproductId: parentProductIds = []
            } = filterData.selectedIds || {};

            const productIdsStr = productId.join(",");
            const categoryIdsStr = categoryId.join(",");
            const parentProductIdsStr = parentProductIds.join(",");

            const queryParams = new URLSearchParams({
              start_date: formattedStart,
              end_date: formattedEnd,
              filter: level,
              filter_value: rowId.toLowerCase(),
              parent_product_id: parentProductIdsStr,
              category_ids: categoryIdsStr,
              product_ids: productIdsStr
            });

            const responseData = await locationWiseData(queryParams);
            if (responseData?.data?.data && responseData?.data?.data.length > 0) {
              setLocationData(responseData?.data?.data);
            } else {
              setLocationData([]);
            }
          } catch (err) {
            console.error("Error fetching locations:", err);
            setLocationData([]); // fallback empty
          } finally {
            setLocationLoading(false);
          }
        });


        $(`#${tableId} tbody`).on("click", ".clickable-category", function (e) {
          e.preventDefault();   // <--- stop navigation/refresh
          e.stopPropagation();
          const categoryId = $(this).data("id")?.toString();
          const asin = $(this).data("asin")?.toString();

          selectedIdsRef.current.clear();
          $(".row-checkbox").prop("checked", false);
          $("#select-all-on-page").prop("checked", false);

          onSelectionChange?.({ categoryId: [], productId: [] });

          if (categoryId && typeof onCategoryClick === "function") {
            onCategoryClick(asin, categoryId);
          }
        });

        $(`#${tableId} tbody`).on("click", ".clickable-parent", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const parentproductId = $(this).data("parent-id")?.toString(); // correct
          const productId = $(this).data("product-id")?.toString();
          const asin = $(this).data("asin")?.toString();

          selectedIdsRef.current.clear();
          $(".row-checkbox").prop("checked", false);
          $("#select-all-on-page").prop("checked", false);

          // onSelectionChange?.({ categoryId: [], productId: productId ? [productId] : [], parentproductId: [parentproductId] });
          onSelectionChange?.({ categoryId: [], productId: [], parentproductId: [] });
          if (parentproductId && typeof onParentProductClick === "function") {
            onParentProductClick(asin, productId, parentproductId);
          }
        });

        const initDragScroll = (slider) => {
          if (!slider) return;
          let isDown = false;
          let startX;
          let scrollLeft;
          let dragged = false;

          slider.style.cursor = "grab";
          slider.style.userSelect = "none";

          slider.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            isDown = true;
            dragged = false;
            slider.style.cursor = "grabbing";
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
          });

          slider.addEventListener("mouseleave", () => {
            isDown = false;
            slider.style.cursor = "grab";
          });

          slider.addEventListener("mouseup", () => {
            isDown = false;
            slider.style.cursor = "grab";
            if (dragged) {
              const preventClick = (clickEvent) => {
                clickEvent.stopImmediatePropagation();
                clickEvent.preventDefault();
                slider.removeEventListener("click", preventClick, true);
              };
              slider.addEventListener("click", preventClick, true);
            }
          });

          slider.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1.5;
            if (Math.abs(x - startX) > 5) {
              dragged = true;
            }
            slider.scrollLeft = scrollLeft - walk;
          });
        };

        const scrollContainer = containerRef.current.querySelector(".table-responsive");
        if (scrollContainer) {
          initDragScroll(scrollContainer);
        }
      } catch (err) {
        console.error("Error initializing DataTable:", err);
      }
    };

    initialize();

    return () => {
      const existingTable = $(`#${tableId}`);
      if ($.fn.DataTable.isDataTable(existingTable)) {
        existingTable.DataTable().clear().destroy(true);
        existingTable.remove();
      }
      $(`#${tableId}`).off();
    };
  }, [data, tableId, idKey, enableSelection, defaultPageLength, refreshTrigger, loading, allColumns]);

  const handleConfirm = async () => {
    setModalOpenLoding(true);
    try {
      const result = await handleConnect("amazon ads");
      if (result?.success) {
        setModalOpenLoding(false);
      }
    } catch (error) {
      console.error("Connection failed:", error);
    }
  };

  const handleCancel = () => setModalOpen(false);
  const handleCancelLocation = () => setLocationModalOpen(false);

  const getSkeletonTableHTML = () => {
    const dynamicLevel = filterData?.level || "default";
    const sequence = {
      salesByState: ["STATE", "ACTUAL UNITS", "TOTAL SALES", "SHARE"],
      topSellingProducts: ["SKU", "ACTUAL UNITS", "TOTAL UNITS REFUNDED", "SHARE"],
      topSellingCategory: ["SKU", "ACTUAL UNITS", "TOTAL UNITS REFUNDED", "SHARE"],
      adsAnalyse: [
        "NAME", "BRAND", "IMPRESSIONS", "CLICKS", "CTR", "CPC", "SPEND",
        "Ads SALES", "Ads UNITS", "NET SALES", "ACTUAL ORDERS", "ACTUAL UNITS",
      ],
      actionableCondition: ["NAME", "ACTUAL ORDERS", "ACTUAL UNITS", "RETURN UNITS", "NET SALES", "RETURNS %", "REJECTED %", "CANCELLED %", "REPLACEMENT %", "FEES %"],
      "regionalLevelSales-region": ["NAME", "NET SALES", "ACTUAL UNITS", "RETURN UNITS"],
      timeSalesAnalysisId: ["NAME", "NET SALES", "ACTUAL UNITS", "RETURN UNITS", "RETURNS %"],
      productGrowthId: ["SKU", "MAY 2025"],
      [`rrSales-${dynamicLevel}`]: ["NAME", "ACTUAL UNITS", "REFUND", "CANCELLED UNITS", "REPLACEMENT UNITS"],
    };

    // Pick headers based on tableId, or fallback to a default set
    const headers = sequence[tableId] || ["NAME", "NET SALES", "ACTUAL UNITS", "RETURN UNITS"];

    const skeletonRow = `
      <tr>
        ${enableSelection ? "<td><div class='skeleton-box skeleton-checkbox'></div></td>" : ""}
        ${headers.map((_, idx) => {
      if (idx === 0) {
        return `
              <td>
                <div class="skeleton-product">
                  <div class="skeleton-image"></div>
                  <div class="skeleton-text-group">
                    <div class="skeleton-title"></div>
                    <div class="skeleton-subtitle"></div>
                  </div>
                </div>
              </td>`;
      }
      return "<td><div class='skeleton-box'></div></td>";
    }).join("")}
      </tr>`;

    return `
    <div class="table-wrapper">
      <div class="table-toolbar">
        <div class="search-placeholder">
          <div class="skeleton-search-icon"></div>
          <div class="skeleton-search-input"></div>
        </div>
        <div class="export-icons">
          <div class="skeleton-icon"></div>
          <div class="skeleton-icon"></div>
        </div>
      </div>
      <table id="${tableId}" class="display table" style="width:100%">
        <thead class="table-header">
          <tr>
            ${enableSelection ? "<th class='skeleton-th'></th>" : ""}
            ${headers.map(h => `<th class='skeleton-th'>${h}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${Array.from({ length: 10 }).map(() => skeletonRow).join("")}
        </tbody>
      </table>
    </div>
    `;
  };

  const showNoDataMessage = delayedEmpty;
  return (
    <>
      <div ref={containerRef} />
      {showInfoComponent && (
        <ConfirmModal
          show={modalOpen}
          title="Verified Account?"
          message="The value will be updated once your Amazon Ads account has been successfully connected."
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          loading={modalOpenLoading}
        />
      )}

      {locationModalOpen && (
        <>
          {locationLoading ? (
            <div
            />
          ) : locationData.length > 0 ? (
            <AreaTableModal show={locationModalOpen}
              title={selectedLocationName}
              data={locationData}
              categoryName={selectedLocationDetails.state || selectedLocationDetails.city || selectedLocationDetails.pincode}
              onCancel={handleCancelLocation}
              permission={level === "state" ? permission?.data?.area_wise_insights?.state_section?.specific_details : selectedLocationDetails.city ? permission?.data?.area_wise_insights?.city_section?.specific_details : permission?.data?.area_wise_insights?.pincode_section?.specific_details}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }} className='no-data-found'>
              No data found for the given criteria.
            </div>

          )}
        </>
      )}

    </>
  );
};

export default NormalTable;